module.exports = __webpack_public_path__ + "static/media/fuel-filter-change.5c758f67.svg";